<template>
    <div class="entity-class-modal">
        <TitleBaseBox :title="titleTxt" @close="close" @cancel="cancelClick" @confirm="submit">
            <div class="content">
                <el-form ref="form" :model="form" :rules="rules" label-width="100px" label-position="left">
                    <el-form-item label="分类名称" prop="classifyName" class="prop-item">
                        <el-input v-model="form.classifyName" @blur="changeHandle" placeholder="请输入" show-word-limit />
                    </el-form-item>
                </el-form>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import { addEntityClasses } from "../server";

export default {
    name: "EntityClassesEdit",
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    components: { TitleBaseBox },
    data() {
        return {
            titleTxt: "新增实体分类",
            form: {
                classifyName: "",
            },
            rules: {
                classifyName: [{ required: true, message: "请输入分类名称", trigger: "blur" }]
            }
        };
    },
    computed: {
        gameId() {
            return this.$store.state.zhiji.gameState.gameId;
        }
    },
    methods: {
        close() {
            this.$emit("closeModal");
        },
        cancelClick() {
            this.close();
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.addAction();
                } else {
                    return false;
                }
            });
        },
        addAction() {
            let arr = this.data.path.split("/");
            addEntityClasses({ 
                gameId: this.gameId,
                classifyName: this.form.classifyName,
                parentClassifyId: this.data.path ? arr[arr.length - 1] : 0,
            }).then(() => {
                this.data.confirm && this.data.confirm();
            });
            this.close();
        },
        changeHandle(el) {
            // 把<>过滤掉
            this.form.classifyName = el.target.value.replace(/[<>]/g, "")
        }
    }
};
</script>

<style lang="less" scoped>
.entity-class-modal {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;
    .content {
        width: 500px;
        .prop-item:last-child {
            margin-bottom: 0;
            .el-checkbox-group {
                width: 70%;
                .el-checkbox {
                    margin-bottom: 14px;
                }
            }
        }
    }
}
</style>
